import { Link } from "react-router-dom";
import { cn } from "../lib/utils";

// Pulsante pill riutilizzabile.
export const PillButton = ({ to, href, children, variant = "primary", className = "", testid, onClick, type }) => {
  const base =
    "inline-flex items-center justify-center gap-2 rounded-full px-7 py-3.5 text-sm font-medium tracking-wide transition-[background-color,color,transform,border-color] duration-300 will-change-transform hover:-translate-y-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sage focus-visible:ring-offset-2 focus-visible:ring-offset-cream";
  const variants = {
    primary: "bg-sage text-cream hover:bg-sage-dark",
    outline: "border border-ink/25 text-ink hover:border-ink hover:bg-ink hover:text-cream",
    ghost: "text-ink hover:text-sage-dark",
  };
  const cls = cn(base, variants[variant], className);

  if (to) {
    return (
      <Link to={to} className={cls} data-testid={testid} onClick={onClick}>
        {children}
      </Link>
    );
  }
  if (href) {
    return (
      <a href={href} className={cls} data-testid={testid} onClick={onClick}>
        {children}
      </a>
    );
  }
  return (
    <button type={type || "button"} className={cls} data-testid={testid} onClick={onClick}>
      {children}
    </button>
  );
};
